import { Component, OnDestroy, ViewChild, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { NbSidebarService, NbDialogService } from '@nebular/theme';
import { LayoutService } from '../../@core/utils';
import { CommonService } from '../../shared/services/commom.service';
import { EncriptyUtilService } from '../../shared/services/encripty-util.service';
import { DashboardService } from './dashboard.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpringDatatablePaginationService } from '../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { SpringDatatablePagination } from '../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { PagesService } from '../pages.service';
import { HeaderService } from '../../@theme/components/header/header.service';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { ColorSchema } from '../../../assets/colors-schemas/color-schema';
import { DateUtilService } from '../../shared/services/date-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {MENU_ITEMS, MENU_ITEMS_IGNORED} from '../../pages/pages-menu';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../shared/services/datatable.service';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { LoginComponent } from '../login/login.component';
import { event } from 'jquery';
import { DocumentoHelper } from '../../shared/utils/documento.helper';

registerLocaleData(localePtBr, 'pt-Br');


interface CardSettings {
  id: number;
  title: string;
  iconClass: string;
  type: string;
  produtoEscolhido: boolean;
  produtoMigrado: boolean;
  produtoDescricao;
}

@Component({
  selector: 'ngx-dashboard',
  styleUrls: ['./dashboard.component.scss'],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit, OnDestroy {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent

  public produtoInfo = null;
  public listProdutos: any = [];
  public isBackoffice = false;
  public isRelatorio = false;
  //public isTitulo = false;
  public totalAmount = 0;
  public valorVenda = null;
  public cnpjCpf = null;
  public agendaRecebimentos: any[];

  public ultimasVendas: any[];

  public tableLimit = 10;
  public formIdentificaClie = null;
  public formSimulaVenda = null;
  public listTaxa = null;
  public listBandeira = null;
  public listTipo = null;
  public rowData = null;
  public data = null;
  public showCompraOnline: boolean = true
  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public receivables_less_30 = null;      //créditos menos 30
  public receivables_greater_30 = null;  //recebíveis maiores 30
  public payment_account = null;        //conta de pagamento
  public valorRecebiveis = null;
  public saldoOneradoEfeito = null;
  public creditosContaCorrente = null;
  //public saldoTransacoesFuturas = null;
  //public saldoFuturo = null;
  //public saldoTransacoesAtuais = null;
  public contaPagto = null;
  public adquirenteTrivale = null;
  public adquirenteAGL = null;
  public saldoCerc = null;
  public isSaldoCredenciadora = null;


  public listQtdDiasAgl = [
    { description: "7 Dias", value: 7 },
    { description: "15 Dias", value: 15 },
    { description: "30 Dias", value: 30 },
  ];

  public listTipoInfoAgl = [
    { description: "VENDAS", value: 'sales' },
    { description: "RECEBIMENTOS", value: 'earnings' },
    { description: "RECEBIMENTOS FUTUROS", value: 'future-earnings' },
  ];

  private listChartOptions = [
    { description: "Bandeiras", value: "flags" },
    { description: "Formas de pagamento", value: "mode" },
    { description: "Comparativo por dia", value: "comparative" },
  ];

  public infoSales: Array<any> = [];
  public infoEarnings: Array<any> = [];
  public infoFutureEarnings: Array<any> = [];

  public aglRowData: Array<any> = [];
  public aglFlagsRowData: Array<any> = [];
  public aglTypesModeData: Array<any> = [];
  public aglComparativeRowData: Array<any> = [];

  public flagsMap: Array<any> = [
    { description: 'VISA', image: 'assets/images/visa.png' },
    { description: 'MASTERCARD', image: 'assets/images/mastercard.png' },
    { description: 'ELO', image: 'assets/images/elo.png' },
    { description: 'VALECARD', image: 'assets/images/valecard.png' },
    { description: 'HIPERCARD', image: 'assets/images/hipercard.png' },
    { description: 'ONUS', image: 'assets/images/on-us.png' },
    { description: 'BANRICOMPRAS', image: 'assets/images/banricompras.png' },

  ];

  formPesquisaAgl: FormGroup = this.formBuilder.group({
    qtdDias: [null, Validators.required],
    tipoInfo: [null, Validators.required]
  });



  //pie
  showLabels = true;

  view: any[] = [1000, 400];

  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Bandeiras';
  showYAxisLabel = true;
  yAxisLabel = 'Valor';
  timeline = true;

  colorScheme = {
    domain: ColorSchema.picnic,
  };

  public customLogin = null;

  constructor(
    private sidebarService: NbSidebarService,
    private layoutService: LayoutService,
    private commonService: CommonService,
    private encriptyService: EncriptyUtilService,
    private service: DashboardService,
    private notificationsService: NotificationsService,
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private pageService: PagesService,
    private headerService: HeaderService,
    private activatedRoute: ActivatedRoute,
    private dateUtil: DateUtilService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService,

  ) {
    this.paginationService.setDatatablePagination(this.datatablePagination);
    this.formIdentificaClie = this.formBuilder.group({

      cnpjCpf: [''],
      razaoSocial: [null],
    });

    let dominio = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-domain'));

    if (dominio !== 'BACKOFFICE') {
      this.findProducts();
      this.isBackoffice = false;
    } else {
      this.isBackoffice = true;
    }

    if (dominio === 'EMPRESA') {
      this.showCompraOnline = false;
    } else {
      this.showCompraOnline = true;
    }

    this.listTaxa = [

      {
        tipoTaxa: 'USUARIO',
        descricao: 'Usuário'
      },
      {
        tipoTaxa: 'ESTABELECIMENTO',
        descricao: 'Estabelecimento'
      },
    ];

    this.listBandeira = [

      {
        bandeira: 'MASTERCARD',
        descricao: 'Mastercard'
      },
      {
        bandeira: 'ELO',
        descricao: 'Elo'
      },
      {
        bandeira: 'VISA',
        descricao: 'Visa'
      },
    ];

    this.listTipo = [

      {
        modalidade: 'CREDITO',
        descricao: 'Crédito'
      },
      {
        modalidade: 'DEBITO',
        descricao: 'Débito'
      },
    ];

    this.formSimulaVenda = this.formBuilder.group({
      valorVenda: [null],
      tipoTaxa: [null],
      bandeira: [null],
      modalidade: [null],
      valorPago: [null],
      valorReceber: [null],

    });

    this.agendaRecebimentos = [
      {
        data: new Date(),
        diaSemana: "Hoje",
        valor: 2555545.23,
      },
      {
        data: new Date("2020-04-07"),
        diaSemana: "Terça",
        valor: 200.26,
      },
      {
        data: new Date("2020-04-08"),
        diaSemana: "Quarta",
        valor: 200.01,
      },
      {
        data: new Date("2020-04-09"),
        diaSemana: "Quinta",
        valor: 200.00,
      },
      {
        data: new Date("2020-04-10"),
        diaSemana: "Sexta",
        valor: 200.87,
      },
      {
        data: new Date("2020-04-13"),
        diaSemana: "Segunda",
        valor: 1000.87,
      },
    ]

    this.ultimasVendas = [
      {
        data: new Date(),
        valor: 2545.00,
        bandeira: "MASTERCARD"
      },
      {
        data: new Date("2020-04-05"),
        valor: 255.34,
        bandeira: "ELO"
      },
      {
        data: new Date("2020-04-05"),
        valor: 457.12,
        bandeira: "ONUS"
      },
      {
        data: new Date("2020-04-04"),
        valor: 123.09,
        bandeira: "VALECARD"
      },
      {
        data: new Date("2020-04-04"),
        valor: 2123.35,
        bandeira: "VISA"
      },
      {
        data: new Date("2020-04-04"),
        valor: 790.35,
        bandeira: "HIPERCARD"
      },
      {
        data: new Date("2020-04-03"),
        valor: 10.35,
        bandeira: "MASTERCARD"
      },
    ];

    this.produtoInfo = {
      id: this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id')),
      descricao: this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-description')),
    };

    this.showRelatorio();

    //this.saldoTransacoesAtuais = 0;
    //this.saldoFuturo = 0;
    //this.saldoTransacoesFuturas = 0;
    this.saldoCerc = 0;

  }

  ngOnInit() {

    this.datatableService.subscribeTable(this.myTable);

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;

  }

  saldoCC() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'contaCorrente',
      },

    });
  }

  /*saldoFT() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'saldoFuturo',
      },
    });
  }

  saldoMenor() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'saldoMenor',
      },
    });
  }

  saldoBloquado() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'saldoBloquado',
      },
    });
  }

  recebimentoDia() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'recebimentoDia',
      },
    });
  }*/

  /*saldoMaior() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'saldoMaior',
      },
    });
  }*/

  saldoRecebiveis() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'valorRecebiveis',
      },
    });

  }

  saldoOutrosRecebiveis() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'outrosRecebiveis',
      },
    });
  }

  saldoOnerado() {

    this.dialogService.open(ModalInfoComponent, {
      context: {
        nome: 'saldoOnerado',
      },
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  /** Formata CPF/CNPJ para exibição (numérico e alfanumérico). */
  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  ngOnDestroy() {
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formSimulaVenda.controls['valorVenda'].setValue(null);
      this.notificationsService.error('Não é permitido números negativos!');

    }
    return true;

  }

  findProducts() {

    this.commonService.buscaProdutos()
      .subscribe(
        response => {

          this.listProdutos = this.transformacaoProduto(response);

          if (localStorage.getItem('bway-product-id') !== 'null') {

            let produtoId = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));
            this.listProdutos.forEach(produto => {

              if (produto.id === Number(produtoId)) {
                produto.produtoEscolhido = true;
              }
            });
          }

        });
  }

  async cardsFlowController($event) {

    let serviceError: any = null;
    let params = new HttpParams();
    params = params.append('productId', $event.id);
    this.spinner.show();
    let responseProduct: any = null;
    await this.service.productIdentifyPromise(params)
      .toPromise()
      .then(res => responseProduct = res, err => serviceError = err);

    if (responseProduct == null) {
      this.spinner.hide();
      this.notificationsService.error('Não foi possível identificar o produto.');
      throw serviceError;
    }

    this.produtoInfo.id = responseProduct.produtoId;
    this.produtoInfo.descricao = responseProduct.produtoDescricao;

    localStorage.setItem('bway-token', responseProduct.token);
    localStorage.setItem('bway-product-id', this.encriptyService.encriptyBySecretKey('' + this.produtoInfo.id));
    localStorage.setItem('bway-product-description', this.encriptyService.encriptyBySecretKey(this.produtoInfo.descricao));
    localStorage.setItem('bway-enterprise-federal-id', this.encriptyService.encriptyBySecretKey(responseProduct.cpfCnpj));

    if (responseProduct.produtoDescricao === 'VIAGEM') {
      responseProduct.produtoDescricao = 'DESPESAS';
      this.produtoInfo.descricao = 'DESPESAS';
      this.headerService.getTravelBalances();
    }

    if (responseProduct.produtoDescricao === 'REFEICAO_BANDEIRADO') {
      responseProduct.produtoDescricao = 'REFEIÇÃO';
      this.produtoInfo.descricao = 'REFEIÇÃO';
    }

    if (responseProduct.produtoDescricao === 'ALIMENTACAO_BANDEIRADO') {
      responseProduct.produtoDescricao = 'ALIMENTAÇÃO';
      this.produtoInfo.descricao = 'ALIMENTAÇÃO';
    }

    if (responseProduct.produtoDescricao === 'EMPRESARIAL_BANK') {
      responseProduct.produtoDescricao = 'EMPRESARIAL';
      this.produtoInfo.descricao = 'EMPRESARIAL';
    }

    if (responseProduct.produtoDescricao === 'VALE_ESTAR_BEM') {
      responseProduct.produtoDescricao = 'VALE ESTAR BEM';
      this.produtoInfo.descricao = 'VALE ESTAR BEM';
    }

    if (responseProduct.produtoDescricao === 'FLEXIVEL') {
      responseProduct.produtoDescricao = 'FLEXÍVEL';
      this.produtoInfo.descricao = 'FLEXÍVEL';
    }

    this.headerService.updateHeaderProductDescription(responseProduct.produtoDescricao);
    this.headerService.updateHeaderProductId(responseProduct.produtoId);

    if ($event.title) {
      this.sidebarService.expand('menu-sidebar');
    }

    this.listProdutos.forEach(statusCard => {
      if (statusCard['title'] !== this.produtoInfo.descricao) {
        statusCard['produtoEscolhido'] = false;
      }
    });

    let roles: any = null;
    await this.authService.getRoles()
      .toPromise()
      .then(res => roles = res, err => serviceError = err);

    if (roles == null) {
      this.spinner.hide();
      this.notificationsService.error('Não foi possível carregar as regras de acesso.');
      throw serviceError;
    }

    this.setMenusHidden(MENU_ITEMS, roles);
    this.showRelatorio();
    this.layoutService.changeLayoutSize();
    this.spinner.hide();

    let cnpjRecebedor = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));

    let domain = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-domain'));

    if(domain != 'EMPRESA'){
      this.buscaSaldoCerc(cnpjRecebedor);
    }

    const produtoSelecionado = this.listProdutos.find(
      (p) => p.produtoEscolhido === true,
    );
  }

  setMenusHidden(menus: any[], roles: any[]) {
    menus.forEach(menu => {
      if (!menu.data) {
        return;
      }

      const hasRole = this.hasRole(menu, roles);
      if (hasRole) {
        if (this.shouldHideForRollout(menu)) {
          menu['hidden'] = true;
        } else {
          menu['hidden'] = false;
        }
      } else {
        menu['hidden'] = true;
      }

      if (this.isMenuIgnored(menu)) {
        menu['hidden'] = true;
      }

      if (menu['children'] && menu['children'].length > 0) {
        this.setMenusHidden(menu['children'], roles);
      }
    });
  }

  private hasRole(menu: any, roles: any[]): boolean {
    return menu.data.roles.some(menuRole => roles.indexOf(menuRole) >= 0);
  }

  private shouldHideForRollout(menu: any): boolean {
    if (!menu.data.checkProductRolloutMigrated) {
      return false;
    }

    const selectedProducts = this.listProdutos.filter(produto => produto.produtoEscolhido);
    if (selectedProducts.length > 0) {
      const isMigrated = selectedProducts[0].produtoMigrado;
      return !isMigrated;
    }

    return true;
  }

  private isMenuIgnored(menu: any): boolean {
    if (!menu.link) {
      return false;
    }
    return MENU_ITEMS_IGNORED.some(menuIgnore => menu.link === menuIgnore.link);
  }


  transformacaoProduto(productList: any) {

    let returnData: Array<any> = [];

    let cardsConfig: any = [
      { title: 'ADIANTA', iconClass: 'far fa-money-bill-alt', type: 'primary', produtoDescricao: 'ADIANTA' },
      { title: 'VAREJO', iconClass: 'fas fa-money-check', type: 'warning', produtoDescricao: 'VAREJO' },
      { title: 'PAGAMENTO', iconClass: 'fas fa-coins', type: 'danger', produtoDescricao: 'PAGAMENTO' },
      { title: 'DESPESAS', iconClass: 'fas fa-credit-card', type: 'info', produtoDescricao: 'DESPESAS' },
      { title: 'ALIMENTAÇÃO', iconClass: 'fas fa-address-card', type: 'danger', produtoDescricao: 'ALIMENTACAO_BANDEIRADO' },
      { title: 'REFEIÇÃO', iconClass: 'fas fa-id-card', type: 'info', produtoDescricao: 'REFEICAO_BANDEIRADO' },
      { title: 'EMPRESARIAL', iconClass: 'fas fa-money-check', type: 'info', produtoDescricao: 'EMPRESARIAL_BANK' },
      { title: 'VALE ESTAR BEM', iconClass: 'fas fa-money-check', type: 'info', produtoDescricao: 'VALE_ESTAR_BEM' },
      { title: 'FLEXÍVEL', iconClass: 'fas fa-money-check', type: 'info', produtoDescricao: 'FLEXIVEL' }
    ];


    for (let product of productList) {

      let cardFilter = cardsConfig.filter((cardConfig) => {
        if (product.produtoDescricao === 'VIAGEM') {
          return cardConfig.produtoDescricao === 'DESPESAS';
        }
        return cardConfig.produtoDescricao === product.produtoDescricao;
      });

      if (cardFilter != null && cardFilter.length > 0) {
        let card: CardSettings = {
          id: product.produtoId,
          title: cardFilter[0].title,
          produtoDescricao: product.produtoDescricao,
          iconClass: cardFilter[0].iconClass,
          type: cardFilter[0].type,
          produtoMigrado: product.dataMigracao !== null,
          produtoEscolhido: false,
        };
        returnData.push(card);
      }

    }
    return returnData;
  }

  buscarCliente(data: any, page?: any) {

    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit));

    if (data.cnpjCpf != null && data.cnpjCpf !== '') {
      const tipo = DocumentoHelper.detectarTipoDocumento(data.cnpjCpf);
      const valorBruto = DocumentoHelper.normalizarParaEnvio(data.cnpjCpf, tipo);
      if (valorBruto) {
        params = params.append('cnpj', valorBruto);
      }
    }
    if (data.razaoSocial !== null) {

      params = params.append('razaoSocial', data.razaoSocial);

    }

    if (page && page != null) {
      params = params.append('page', String(page - 1));
    }

    this.spinner.show();

    this.service.buscaCliente(params, (response => {

      this.rowData = response.content;
      this.rowData = this.rowData.map(data => {
        return {
          id: data.id,
          cnpj: data.cnpj,
          razaoSocial: data.razaoSocial,
          nomeFantasia: data.nomeFantasia,
          status: data.status,
        };

      });
      this.spinner.hide();
      this.paginationService.setInfo(response);
    }), error => {
      this.spinner.hide();
      this.notificationsService.error(error.message);
    });


  }

  limpaForm() {

    this.formIdentificaClie.controls['cnpjCpf'].setValue(null);

  }

  identificaCliente(data) {

    let register = {

      enterpriseId: data.id,

    }

    if (data.id != null) {

      this.service.identifyCompany(
        register,
        (response) => {

          localStorage.setItem('bway-token', response.token);
          localStorage.setItem('bway-enterprise-name', this.encriptyService.encriptyBySecretKey(response.empresaRazaoSocial));
          localStorage.setItem('bway-enterprise-federal-id', this.encriptyService.encriptyBySecretKey(response.cpfCnpj));
          this.headerService.updateHeaderEnterpriseName(response.empresaRazaoSocial);

          this.findProducts();

        }, (error) => {
          this.notificationsService.error(error.message);
        })

    }

  }

  showRelatorio() {
    if (this.produtoInfo && this.produtoInfo.descricao && this.produtoInfo.descricao === 'VAREJO') {
      this.isRelatorio = true;
      this.visaoDashboard();
    } else {
      this.isRelatorio = false;
    }
  }

  /*bloqueioSaldo() {

    this.service.retailAccountBalanceBlocked(null, (response) => {

     // this.saldoTransacoesFuturas = response.saldoTransacoesAtuais;
     // this.saldoTransacoesAtuais = response.saldoTransacoesFuturas;

    }, (error) => this.notificationsService.error('Não foi possível obter informações de saldo.'))

  }*/

  visaoDashboard() {

    this.fillAglServices();

    this.valorRecebiveis = 0;
    this.creditosContaCorrente = 0;
    this.saldoOneradoEfeito = 0;

    this.service.balanceDetailViewList(null, (response) => {

      for (let recebivel of response.balanceDetailViewList) {

        if (recebivel.type === 'PAYMENT_ACCOUNT') {
          this.creditosContaCorrente = recebivel.amount;
        } else if (recebivel.type === 'ENCUMBERED_BALANCE') {
          this.saldoOneradoEfeito = recebivel.amount;
        }

      }

      //this.bloqueioSaldo();

      this.totalAmount = this.creditosContaCorrente;

    }, (error) => this.notificationsService.error('Não foi possível obter informações de saldo.'))


    this.service.balanceValorRecebiveis(null, (response) => {

      this.valorRecebiveis = response.valorLiquidoDisponivel;

    }, (error) => this.notificationsService.error('Não foi possível obter informações de saldo.'))

  }

  showCardModal(data) {

    let valorVenda = this.encriptyService.encriptyBySecretKey('' + data.valorVenda);
    let tipoTaxa = this.encriptyService.encriptyBySecretKey('' + data.tipoTaxa);
    let bandeira = this.encriptyService.encriptyBySecretKey('' + data.bandeira);
    let modalidade = this.encriptyService.encriptyBySecretKey('' + data.modalidade);

    let params = {
      'valorVenda': valorVenda,
      'tipoTaxa': tipoTaxa,
      'bandeira': bandeira,
      'modalidade': modalidade
    }
    this.router.navigate(['/pages/pagamento-inteligente/simulacao-venda'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  objeto(data) {
    return {
      name: data.description,
      value: data.totalValue,
    }
  };

  fillAgilliInfoSuccess(response: any) {
    this.aglRowData = response.value[0].transaction;
    this.aglFlagsRowData = response.value[0].transactionFlag.map(data => {
      return this.objeto(data)
    });
    this.aglTypesModeData = response.value[0].transactionMode.map(data => {
      return this.objeto(data)
    });

    this.aglComparativeRowData = response.value[0].transaction.map(data => {
      return {
        name: data.description,
        series: [
          {
            name: 'Quantidade',
            value: data.amount,
          },
          {
            name: 'Valor',
            value: data.totalValue,
          }
        ]
      };
    });
  }


  fillAgilliInfo() {

    if (!this.formPesquisaAgl.controls.tipoInfo.valid ||
      this.formPesquisaAgl.value.tipoInfo == null) {
      this.notificationsService.warn('Selecione um tipo de informação!');
      return;

    }

    if (!this.formPesquisaAgl.controls.qtdDias.valid ||
      this.formPesquisaAgl.value.qtdDias == null) {
      this.notificationsService.warn('Selecione a quantidade de dias para pesquisa!');
      return;

    }


    let data: any = this.formPesquisaAgl.value;



    let timestampValue = (Math.round(new Date().getTime() / 1000));
    let cpfCnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));
    let bodyForm: any = {
      cgc: cpfCnpj,
      dataReferencia: timestampValue,
      days: data.qtdDias,
    }

    if (data.tipoInfo === 'future-earnings') {
      this.service.findAgilliFutureEarnings(
        bodyForm,
        (response) => this.fillAgilliInfoSuccess(response),
        (err) => {

        });
    }

  }

  private showChart: string = null;
  changeChart(optionValue: any) {
    if (optionValue === "flags") {
      this.showChart = "flags";
    } else if (optionValue === "mode") {
      this.showChart = "mode";
    } else if (optionValue === "comparative") {
      this.showChart = "comparative";
    }

  }

  async fillAglServices() {
    let timestampValue = (Math.round(new Date().getTime() / 1000));
    let cpfCnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));

    let bodyForm: any = {
      cgc: cpfCnpj,
      dataReferencia: timestampValue,
      days: 15,
    }

    let fillSales: any = null;

    if (fillSales != null) {
      this.infoSales = fillSales.value[0].transactionFlag;
    }

    this.infoSales.forEach(data => {
      let flag = this.flagsMap.find(element => element.description === data.description);
      if (flag) {
        data['image'] = flag.image;
      }
    });

    let fillEarnings: any = null;

    if (fillEarnings != null) {
      this.infoEarnings = fillEarnings.value[0].transaction;
    }

    this.infoEarnings = this.infoEarnings.map((data) => {
      return {
        description: this.dateUtil.parseDate(data.description, 'DD/MM/YYYY'),
        totalValue: data.totalValue
      }

    })
  }

  buscaSaldoCerc(data) {

    let params = new HttpParams();

    if (data != null) {
      params = params.append('cnpjCpfReceiver', data)
    }

    this.service.receivablesCerc(params, (response) => {

      this.saldoCerc = response.somaRecebiveisCerc;

      if (this.saldoCerc === 0) {
        this.isSaldoCredenciadora = false;
      } else {
        this.isSaldoCredenciadora = true;
      }

    }, null)


  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getHome() {
    if (this.customLogin != null) {
      return this.customLogin.home;
    }
  }

  getMenu() {
    if (this.customLogin != null) {
      return this.customLogin.menu;
    }
  }

  getLabel() {
    if (this.customLogin != null) {
      return this.customLogin.label;
    }
  }

}
